// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__266kx","filesListContainer":"PosDisputesFiles_filesListContainer__3QRby","filesButton":"PosDisputesFiles_filesButton__3G1yM"};